import Items from './Items'

module.exports = Items.reducer( null, 'SCRIPT', 'projectId', [ 'projectId' ] )
